<div class="col-12">
    <dhs-form [formtype]="'popup'" #formselection [customButton]='btn' [action]="'ADD'" [config]="config" [fieldGroup]="FormObj" (saveFinished)="onSaveFinished($event)" (questionValueChanged)="questionValueChanged($event)">
    </dhs-form>
</div>